var OCS = OCS || {};
OCS.Advisories = OCS.Advisories || {};
OCS.Advisories.Classes = OCS.Advisories.Classes || {};
OCS.Advisories.Functions = OCS.Advisories.Functions || {};
OCS.Advisories.Functions.define_AdvisoryDataEventZone_class = function (in_implements) {
    var implements = [Options];
    /* istanbul ignore if */
    if (in_implements && in_implements.length) {
        implements.combine(in_implements);
    }
    return new Class({
        Implements: implements,
        class_type: "AdvisoryDataEventZone",
        class_name: "AdvisoryDataEventZone",
        options: {
            action: '',
            beginning_time: 0,
            ending_time: 0,
            file: '',
            issued_time: 0
        },
        affects_all: true,
        geometry: {type: "Polygon", coordinates: []},
        initialize: function (op) {
            this.setOptions(op);
        },
        get_properties: function () {
            return this.options;
        }
    });
};
OCS.Advisories.Classes.AdvisoryDataEventZone = OCS.Advisories.Functions.define_AdvisoryDataEventZone_class();
/* istanbul ignore next */
try {
    if (typeof (module) !== 'undefined') {
        module.exports = {
            "init": OCS.Advisories.Functions.define_AdvisoryDataEventZone_class
        };
    }
} catch (e) {

}